/*
 * @Descripttion:
 * @version:
 * @Author: xKai
 * @Date: 2019-08-22 11:33:50
 * @LastEditors: your name
 * @LastEditTime: 2022-01-15 14:17:45
 */
import request from "@/utils/request";

// 获取摄像机信息树
export const getCameraTree = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/treeinfo",
    params: data
  });
};

// 查询截图列表
export const getCameraInfo = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/playVideo",
    params: data
  });
};
// 上传截图
export const imgUpload = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/img-upload",
    method: "post",
    data: data
  });
};

// 上传截图
export const imgUploadWill = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/img-upload/v2",
    method: "post",
    data: data
  });
};

// 查询截图列表
export const getCameraImg = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/img-show",
    method: "post",
    data: data
  });
};
//  删除上传的数据
export const delData = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/del-data",
    method: "get",
    params: data
  });
};

// 截图id/督导单id删除督导单
export const delSupervise = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/delete",
    params: data
  });
};

// 查询视频列表
export const getCameraVideo = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/video-show",
    params: data
  });
};
// 展示录像数据
export const videoShowNew = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/video-show-new",
    method: "post",
    data: data
  });
};
// 查询督导问题列表
export const getQuestion = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/supervise-question",
    params: data
  });
};

// 保存督导数据
export const saveSupervise = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/save",
    method: "post",
    data: data
  });
};

// 修改督导数据
export const updateSupervise = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/update",
    method: "post",
    data: data
  });
};

// 根据截图id筛选更多截图进行督导
export const getOtherImg = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/screen-img",
    params: data
  });
};

// 通过截图id查询督导信息
export const getSuperviseByImg = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/supervise/search/img",
    params: data
  });
};

// 获取自定义摄像机信息树
export const getCustomTree = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/treeinfo/custom/search",
    params: data
  });
}; // 获取公共摄像机信息树
export const getCommonTree = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/treeinfo/common/search",
    params: data
  });
};
// 用户往分组添加相机
export const postAddCamera = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/group/add-camera",
    method: "post",
    data: data
  });
};

// 用户往分组删除相机
export const postDeleteCamera = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/group/delete-camera",
    method: "post",
    data: data
  });
};

// 用户创建相机分组
export const getCreateGroup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/group/create",
    params: data
  });
};

// 用户删除相机分组
export const getDeleteGroup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/group/delete",
    params: data
  });
};

// 用户修改相机分组名称
export const getModifyGroup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/group/modify",
    params: data
  });
};
// export const videoDownload = data => request('/api/HZ-AF-SAFETY/smart/safety/camera/video-download1', data, 'GETDOWN') //下载视频

// 通过地图机构id获取地图关联的所有的相机列表
export const getCameraByMapId = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/camera_map",
    params: data
  });
};

/**
 视频预案接口
 *
 */

// 删除视频预案里的相机信息
export const delCamera = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/plan/delete-camera",
    params: data
  });
};

// 删除视频预案信息
export const delPlan = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/plan/delete",
    params: data
  });
};

// 用户根据私有/共有获取已保存的视频预案信息
export const getPlan = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/plan/get",
    params: data
  });
};

// 预案ID获取关联相机id
export const getCamera = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/plan/get-camera",
    params: data
  });
};

// 保存/添加视频预案信息
export const savePlan = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/plan/save",
    method: "post",
    data: data
  });
};

/**
 督导检查接口
 *
 */
// 用户新建督导单
export const createSup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/create",
    method: "post",
    data: data
  });
};

// 修改用户新建督导单
export const getCreateSup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/create/v2",
    method: "post",
    data: data
  });
};

// 督导单反馈
export const feedback = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/feedback",
    method: "post",
    data: data
  });
};

// 根据条件查询督导单
export const getSup = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/get",
    method: "post",
    data: data
  });
};

// 安全隐患-分页查询安全隐患记录分页列表 2020-10-27
// export const queryAqjcAqyhjlPage  = data => request('/aqjc/yhjl/queryAqjcAqyhjlPage', data,"POST")
export const queryAqjcAqyhjlPage = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryAqjcAqyhjlPage",
    method: "post",
    data: data
  });
};

// 根据id获取督导单明细信息
export const getDetail = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/get-detail",
    params: data
  });
};

// 获取用户列表
export const getDutyUser = data => {
  return request({
    url: "/api/HZ-USER-ROLE/user_api/search/dutyUser",
    params: data
  });
};

// 获取督导用户列表
export const getDuDaoGetUser = data => {
  return request({
    url: "/api/HZ-USER-ROLE/user_api/search/duDaoGetUser",
    params: data
  });
};

// 获取督导类型
export const getSupSort = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/get-supSort",
    params: data
  });
};

// 获取事发分类
export const getType = () => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/getType"
  });
};

// 根据督导单ID获取推送人员查看情况
export const getReceiver = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/get-receiver",
    params: data
  });
};
// 查看我收到的督导未读数
export const getReceiverNoRead = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/camera-video/biz/sup/get-receiver-no-read",
    params: data
  });
};
// 视频预案上墙
export const vdPlay = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/safety/screen/decoder/config/vdPlay",
    method: "post",
    data: data
  });
};
// 重置大屏状态
export const screenReset = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/safety/screen/decoder/screenReset",
    method: "post",
    data: data
  });
};

// 获取摄像机列表，同时会返回第一条设备的详细数据
export const getCameraDeviceList = data => {
  return request({
    url: "/api/HZ-AF-BASICS/safety/cameraMaintain/getCameraDeviceList",
    method: "post",
    data: data
  });
};

// 根据区域ID查询区域的子节点
export const childNode = data => {
  return request({
    url: "/api/HZ-AF-BASICS/safety/areaInfo/childNode",
    method: "post",
    data: data
  });
};

// 2020-10-27
export const rootNode = query => {
  const data = {
    url: "/api/HZ-AF-BASICS/safety/areaInfo/rootNode",
    method: "get"
  };
  if (query) {
    // data.params.query;
  }
  return request(data);
};
/**
 * 搜索区域树
 * @param {*} query
 * {
 *  areaName (string, optional): 区域名称模糊查询 ,
    deptId (integer, optional): 关联部门（可选） ,
    parentAreaId (integer, optional): 从这个区域ID开始搜索，不传时为用户所在机构的所有区域
 * }
 */
export const search = query => {
  return request({
    url: "/api/HZ-AF-BASICS/safety/areaInfo/search",
    method: "post",
    data: query
  });
};
// export const searchSictionary = data => request('', data, 'GET') // 数据字典查询
export const searchSictionary = data => {
  return request({
    url: "/api/HZ-SPP-BASE-CONFIG-APPLICATION/smart/manage/search/dictionary",
    params: data
  });
};

// 查询监区监室联动信息
// export const getJianshiJianqu = data =>
//   request('/HZ-SPP-BASE-CONFIG-APPLICATION/prison_treatment/get_jianshi_jianqu', data, 'GET')
export const getJianshiJianqu = data => {
  return request({
    url: "/api/HZ-SPP-BASE-CONFIG-APPLICATION/prison_treatment/get_jianshi_jianqu",
    params: data
  });
};

// 安全隐患-查询隐患项目
// export const queryWgkfXx = data => request('/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryWgkfXx', data, 'GET')
export const queryWgkfXx = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryWgkfXx",
    params: data
  });
};

// 安全隐患-登记
// export const insert = data => request('/aqjc/yhjl/insert', data, "POST")
export const insert = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/insert",
    method: "post",
    data: data
  });
};

// 安全隐患-详情查询安全隐患记录
// export const queryAqjcAqyhjlInfo = data => request('/aqjc/yhjl/queryAqjcAqyhjlInfo', data, "GET")
export const queryAqjcAqyhjlInfo = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryAqjcAqyhjlInfo",
    params: data
  });
};

// 通过相机 id 获取相关信息
export const getCameradetails = data => {
  return request({
    url: "/api/HZ-AF-BASICS/safety/cameraMaintain/getCameraDeviceDtls",
    method: "post",
    data: data
  });
};

// 安全隐患-查询隐患项目
export const queryByWgkfXxTree = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS/aqjc/yhjl/queryByWgkfXxTree",
    params: data
  });
};

export const getCusTypeCusNum = data => {
  return request({
    url: "/api/HZ-SPP-BASE-CONFIG-APPLICATION/prison_treatment/get_cusType_cusNum",
    params: data
  });
};
export const queryAqjcAqyhjlCount = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryAqjcAqyhjlCount",
    params: data
  });
};
export const serachQueryByWgkfXxTree = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/queryByWgkfXxTree",
    params: data
  });
};
export const updateFk = data => {
  return request({
    url: "/api/HZ-SPP-STATISTICS-RESULTS-APPLICATION/aqjc/yhjl/updateFk",
    method: "post",
    data: data
  });
};

// 视频截图上传服务
export const imgUploadNew = data => {
  return request({
    url: "/api/HZ-AF-SAFETY/smart/safety/camera/img-upload-new",
    method: "post",
    data: data
  });
};

// 实时视频
export const queryRealVideoTree = data => {
  return request({
    // url: "/apiData/hz-data-community/smart/safety/camera/treeinfo",
    url: "/apiData/hz-data-community/smart/safety/camera/treeArea",
    method: "get",
    params: data
  });
};

// 查询区域对应摄像头
export const queryTreeAreaVideo = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/treeArea",
    method: "get",
    params: data
  });
};
// 查询区域对应摄像头 所有按权限走
export const queryTreeAreaVideoAll = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/treeAreaAll",
    method: "post",
    data: data
  });
};

// 查询区域对应摄像头  
export const queryAllTreeAreaVideo = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/tree",
    method: "get",
    params: data
  });
};

// 播放视频数据
export const playVideo = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/playVideo",
    method: "get",
    params: data
  });
};
// 播放视频数据根据DeviceId
export const playVideoByDeviceId = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/other/playVideo",
    method: "get",
    params: data
  });
};

// 获取区域树  设备区域
export const getResource = data => {
  return request({
    url: "/apiData/hz-data-community/resources_tree/resource",
    method: "get",
    params: data
  });
};

// 获取区域树  设备区域
export const getSubType = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/sub_type",
    method: "get",
    params: data
  });
};

// 获取摄像机  根据设备ID
export const getCameraDeviceDtls = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/camera/getCameraDeviceDtls/otherid",
    method: "get",
    params: data
  });
};

// 获取摄像机  根据卡口编号
export const getCameraTollgate = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/tollgate/playVideo",
    method: "get",
    params: data
  });
};

/**
 * 视频巡逻
 * 
 */

// 预案保存
export const patrolNodeSave = data => {
  return request({
    url: "/apiData/hz-data-community/af/patrol_info/save",
    method: "post",
    data: data
  });
};
// 预案更新
export const patrolSave = data => {
  return request({
    url: "/apiData/hz-data-community/af/patrol_node/save",
    method: "post",
    data: data
  });
};

// 预案列表
export const patrolInfoList = data => {
  return request({
    url: "/apiData/hz-data-community/af/patrol_info/list",
    method: "post",
    data: data
  });
};

// 根据预案ID获取预案摄像头信息
export const patrolIdList = data => {
  return request({
    url: "/apiData/hz-data-community/af/patrol_node/device/patrol_id",
    method: "get",
    params: data
  });
};

// 根据预案ID获取预案摄像头信息
export const patrolIdDetele = data => {
  return request({
    url: "/apiData/hz-data-community/af/patrol_info/detele",
    method: "post",
    data: data
  });
};